<mat-card *ngIf="!updateMode">{{'addAdvertize' | translate}}</mat-card>
<mat-card *ngIf="updateMode">{{'updateAdvertize' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
  <!-- <span class="spacer"></span> -->
 
  <button mat-raised-button color="primary" (click)="submit()" 
  [disabled]="(arabName.invalid || (files.length == 0 && advertize.imgUrl == null))">
    <mat-icon>done</mat-icon>
    {{'submit' | translate}}</button>
    &nbsp;
  <button mat-raised-button (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon>
    {{'back' | translate}}</button>
    &nbsp;
</div>


<mat-grid-list cols="5" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
        <mat-form-field  appearance="standard">
            <mat-label>{{'arabicDesc' | translate}}</mat-label>
            <input matInput [(ngModel)]="advertize.arabicDescription" required #arabName="ngModel">
            <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error>
          </mat-form-field>
          
    </mat-grid-tile>
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
        <mat-form-field  appearance="standard">
            <mat-label>{{'englishDesc' | translate}}</mat-label>
            <input matInput [(ngModel)]="advertize.englishDescription" #engName="ngModel">
          </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile> <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="active">{{'active' | translate}}</mat-checkbox></mat-grid-tile>
  </mat-grid-list>


  <mat-grid-list cols="3" rowHeight="200px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
        
        <input type="file" class="dropify" (change)="onSelectImage($event)" required />
    </mat-grid-tile>
  </mat-grid-list>
    

  <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
